export const LANGUAGES = [
  { name: "bulgarian", code: "bg", flag: "🇧🇬" },
  { name: "catalan", code: "ca", flag: "🇪🇸" },
  { name: "chineseHK", code: "zh-HK", flag: "🇭🇰" },
  { name: "chineseSimplified", code: "zh-CN", flag: "🇨🇳" },
  { name: "chineseTraditional", code: "zh-TW", flag: "🇹🇼" },
  { name: "czech", code: "cs", flag: "🇨🇿" },
  { name: "danish", code: "da", flag: "🇩🇰" },
  { name: "dutch", code: "nl", flag: "🇳🇱" },
  { name: "english", code: "en", flag: "🇬🇧" },
  { name: "englishUS", code: "en-US", flag: "🇺🇸" },
  { name: "englishUK", code: "en-GB", flag: "🇬🇧" },
  { name: "englishIndia", code: "en-IN", flag: "🇮🇳" },
  { name: "englishAustralia", code: "en-AU", flag: "🇦🇺" },
  { name: "englishNewZealand", code: "en-NZ", flag: "🇳🇿" },
  { name: "flemish", code: "nl-BE", flag: "🇧🇪" },
  { name: "estonian", code: "et", flag: "🇪🇪" },
  { name: "finnish", code: "fi", flag: "🇫🇮" },
  { name: "french", code: "fr", flag: "🇫🇷" },
  { name: "german", code: "de", flag: "🇩🇪" },
  { name: "germanSwiss", code: "de-CH", flag: "🇨🇭" },
  { name: "greek", code: "el", flag: "🇬🇷" },
  { name: "hindi", code: "hi", flag: "🇮🇳" },
  { name: "hungarian", code: "hu", flag: "🇭🇺" },
  { name: "italian", code: "it", flag: "🇮🇹" },
  { name: "indonesian", code: "id", flag: "🇮🇩" },
  { name: "japanese", code: "ja", flag: "🇯🇵" },
  { name: "korean", code: "ko", flag: "🇰🇷" },
  { name: "latvian", code: "lv", flag: "🇱🇻" },
  { name: "lithuanian", code: "lt", flag: "🇱🇹" },
  { name: "malay", code: "ms", flag: "🇲🇾" },
  { name: "norwegian", code: "no", flag: "🇳🇴" },
  { name: "polish", code: "pl", flag: "🇵🇱" },
  { name: "portuguese", code: "pt-PT", flag: "🇵🇹" },
  { name: "portugueseBrazil", code: "pt-BR", flag: "🇧🇷" },
  { name: "romanian", code: "ro", flag: "🇷🇴" },
  { name: "russian", code: "ru", flag: "🇷🇺" },
  { name: "slovak", code: "sk", flag: "🇸🇰" },
  { name: "spanish", code: "es", flag: "🇪🇸" },
  { name: "swedish", code: "sv", flag: "🇸🇪" },
  { name: "thai", code: "th", flag: "🇹🇭" },
  { name: "turkish", code: "tr", flag: "🇹🇷" },
  { name: "ukrainian", code: "uk", flag: "🇺🇦" },
  { name: "vietnamese", code: "vi", flag: "🇻🇳" },
];

export const LANGUAGES_TRANSLATE = [
  { name: "abkhazian", code: "ab", flag: "🇦🇧" },
  { name: "afar", code: "aa", flag: "🇪🇹" },
  { name: "afrikaans", code: "af", flag: "🇿🇦" },
  { name: "akan", code: "ak", flag: "🇬🇭" },
  { name: "albanian", code: "sq", flag: "🇦🇱" },
  { name: "amharic", code: "am", flag: "🇪🇹" },
  { name: "arabic", code: "ar", flag: "🇸🇦" },
  { name: "aragonese", code: "an", flag: "🇪🇸" },
  { name: "armenian", code: "hy", flag: "🇦🇲" },
  { name: "assamese", code: "as", flag: "🇮🇳" },
  { name: "avaric", code: "av", flag: "🇷🇺" },
  { name: "avestan", code: "ae", flag: "🇮🇷" },
  { name: "aymara", code: "ay", flag: "🇧🇴" },
  { name: "azerbaijani", code: "az", flag: "🇦🇿" },
  { name: "bambara", code: "bm", flag: "🇲🇱" },
  { name: "bashkir", code: "ba", flag: "🇷🇺" },
  { name: "basque", code: "eu", flag: "🇪🇸" },
  { name: "belarusian", code: "be", flag: "🇧🇾" },
  { name: "bengali", code: "bn", flag: "🇧🇩" },
  { name: "bihariLanguages", code: "bh", flag: "🇮🇳" },
  { name: "bislama", code: "bi", flag: "🇻🇺" },
  { name: "bosnian", code: "bs", flag: "🇧🇦" },
  { name: "breton", code: "br", flag: "🇫🇷" },
  { name: "bulgarian", code: "bg", flag: "🇧🇬" }, // Existing, unchanged
  { name: "burmese", code: "my", flag: "🇲🇲" },
  { name: "catalan", code: "ca", flag: "🇪🇸" }, // Existing, unchanged
  { name: "centralKhmer", code: "km", flag: "🇰🇭" },
  { name: "chamorro", code: "ch", flag: "🇬🇺" },
  { name: "chechen", code: "ce", flag: "🇷🇺" },
  { name: "chewaNyanja", code: "ny", flag: "🇲🇼" },
  { name: "chineseSimplified", code: "zh_hans", flag: "🇨🇳" }, // Existing, unchanged
  { name: "chineseTraditional", code: "zh_hant", flag: "🇹🇼" }, // Existing, unchanged
  { name: "chineseHongKong", code: "zh_hk", flag: "🇭🇰" },
  { name: "churchSlavonic", code: "cu", flag: "🇷🇺" },
  { name: "chuvash", code: "cv", flag: "🇷🇺" },
  { name: "cornish", code: "kw", flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿" },
  { name: "corsican", code: "co", flag: "🇫🇷" },
  { name: "cree", code: "cr", flag: "🇨🇦" },
  { name: "croatian", code: "hr", flag: "🇭🇷" },
  { name: "czech", code: "cs", flag: "🇨🇿" }, // Existing, unchanged
  { name: "danish", code: "da", flag: "🇩🇰" }, // Existing, unchanged
  { name: "dhivehi", code: "dv", flag: "🇲🇻" },
  { name: "dutch", code: "nl", flag: "🇳🇱" }, // Existing, unchanged
  { name: "dzongkha", code: "dz", flag: "🇧🇹" },
  { name: "english", code: "en", flag: "🇬🇧" }, // Existing, unchanged
  { name: "englishUS", code: "en_us", flag: "🇺🇸" },
  { name: "englishIndia", code: "en_in", flag: "🇮🇳" },
  { name: "englishAustralia", code: "en_au", flag: "🇦🇺" },
  { name: "englishNewZealand", code: "en_nz", flag: "🇳🇿" },
  { name: "esperanto", code: "eo", flag: "🌐" },
  { name: "estonian", code: "et", flag: "🇪🇪" }, // Existing, unchanged
  { name: "ewe", code: "ee", flag: "🇹🇬" },
  { name: "faroese", code: "fo", flag: "🇫🇴" },
  { name: "fijian", code: "fj", flag: "🇫🇯" },
  { name: "finnish", code: "fi", flag: "🇫🇮" }, // Existing, unchanged
  { name: "flemish", code: "nl_be", flag: "🇧🇪" },
  { name: "french", code: "fr", flag: "🇫🇷" }, // Existing, unchanged
  { name: "fulah", code: "ff", flag: "🇸🇳" },
  { name: "gaelic", code: "gd", flag: "🏴󠁧󠁢󠁳󠁣󠁴󠁿" },
  { name: "galician", code: "gl", flag: "🇪🇸" },
  { name: "ganda", code: "lg", flag: "🇺🇬" },
  { name: "georgian", code: "ka", flag: "🇬🇪" },
  { name: "german", code: "de", flag: "🇩🇪" }, // Existing, unchanged
  { name: "germanSwiss", code: "de_ch", flag: "🇨🇭" },
  { name: "greek", code: "el", flag: "🇬🇷" }, // Existing, unchanged
  { name: "guarani", code: "gn", flag: "🇵🇾" },
  { name: "gujarati", code: "gu", flag: "🇮🇳" },
  { name: "haitian", code: "ht", flag: "🇭🇹" },
  { name: "hausa", code: "ha", flag: "🇳🇬" },
  { name: "hebrew", code: "he", flag: "🇮🇱" },
  { name: "herero", code: "hz", flag: "🇳🇦" },
  { name: "hindi", code: "hi", flag: "🇮🇳" }, // Existing, unchanged
  { name: "hiriMotu", code: "ho", flag: "🇵🇬" },
  { name: "hungarian", code: "hu", flag: "🇭🇺" }, // Existing, unchanged
  { name: "icelandic", code: "is", flag: "🇮🇸" },
  { name: "ido", code: "io", flag: "🌐" },
  { name: "igbo", code: "ig", flag: "🇳🇬" },
  { name: "indonesian", code: "id", flag: "🇮🇩" }, // Existing, unchanged
  { name: "interlingua", code: "ia", flag: "🌐" },
  { name: "interlingue", code: "ie", flag: "🌐" },
  { name: "inuktitut", code: "iu", flag: "🇨🇦" },
  { name: "inupiaq", code: "ik", flag: "🇺🇸" },
  { name: "irish", code: "ga", flag: "🇮🇪" },
  { name: "italian", code: "it", flag: "🇮🇹" }, // Existing, unchanged
  { name: "japanese", code: "ja", flag: "🇯🇵" }, // Existing, unchanged
  { name: "javanese", code: "jv", flag: "🇮🇩" },
  { name: "kalaallisut", code: "kl", flag: "🇬🇱" },
  { name: "kannada", code: "kn", flag: "🇮🇳" },
  { name: "kanuri", code: "kr", flag: "🇳🇬" },
  { name: "kashmiri", code: "ks", flag: "🇮🇳" },
  { name: "kazakh", code: "kk", flag: "🇰🇿" },
  { name: "kikuyu", code: "ki", flag: "🇰🇪" },
  { name: "kinyarwanda", code: "rw", flag: "🇷🇼" },
  { name: "kirghiz", code: "ky", flag: "🇰🇬" },
  { name: "komi", code: "kv", flag: "🇷🇺" },
  { name: "kongo", code: "kg", flag: "🇨🇩" },
  { name: "korean", code: "ko", flag: "🇰🇷" }, // Existing, unchanged
  { name: "kuanyama", code: "kj", flag: "🇳🇦" },
  { name: "kurdish", code: "ku", flag: "🇮🇶" },
  { name: "lao", code: "lo", flag: "🇱🇦" },
  { name: "latin", code: "la", flag: "🇻🇦" },
  { name: "latvian", code: "lv", flag: "🇱🇻" }, // Existing, unchanged
  { name: "limburgan", code: "li", flag: "🇳🇱" },
  { name: "lingala", code: "ln", flag: "🇨🇩" },
  { name: "lithuanian", code: "lt", flag: "🇱🇹" }, // Existing, unchanged
  { name: "lubaKatanga", code: "lu", flag: "🇨🇩" },
  { name: "luxembourgish", code: "lb", flag: "🇱🇺" },
  { name: "macedonian", code: "mk", flag: "🇲🇰" },
  { name: "malagasy", code: "mg", flag: "🇲🇬" },
  { name: "malay", code: "ms", flag: "🇲🇾" }, // Existing, unchanged
  { name: "malayalam", code: "ml", flag: "🇮🇳" },
  { name: "maltese", code: "mt", flag: "🇲🇹" },
  { name: "manx", code: "gv", flag: "🇮🇲" },
  { name: "maori", code: "mi", flag: "🇳🇿" },
  { name: "marathi", code: "mr", flag: "🇮🇳" },
  { name: "marshallese", code: "mh", flag: "🇲🇭" },
  { name: "mongolian", code: "mn", flag: "🇲🇳" },
  { name: "nauru", code: "na", flag: "🇳🇷" },
  { name: "navajo", code: "nv", flag: "🇺🇸" },
  { name: "ndebeleNorth", code: "nd", flag: "🇿🇼" },
  { name: "ndebeleSouth", code: "nr", flag: "🇿🇦" },
  { name: "ndonga", code: "ng", flag: "🇳🇦" },
  { name: "nepali", code: "ne", flag: "🇳🇵" },
  { name: "northernSami", code: "se", flag: "🇳🇴" },
  { name: "norwegian", code: "no", flag: "🇳🇴" }, // Existing, unchanged
  { name: "norwegianNynorsk", code: "nn", flag: "🇳🇴" },
  { name: "occitan", code: "oc", flag: "🇫🇷" },
  { name: "ojibwa", code: "oj", flag: "🇨🇦" },
  { name: "oriya", code: "or", flag: "🇮🇳" },
  { name: "oromo", code: "om", flag: "🇪🇹" },
  { name: "ossetian", code: "os", flag: "🇷🇺" },
  { name: "pali", code: "pi", flag: "🇮🇳" },
  { name: "panjabi", code: "pa", flag: "🇮🇳" },
  { name: "persian", code: "fa", flag: "🇮🇷" },
  { name: "polish", code: "pl", flag: "🇵🇱" }, // Existing, unchanged
  { name: "portuguese", code: "pt", flag: "🇵🇹" }, // Existing, unchanged
  { name: "portugueseBrazil", code: "pt", flag: "🇧🇷" }, // Existing, unchanged
  { name: "pushto", code: "ps", flag: "🇦🇫" },
  { name: "quechua", code: "qu", flag: "🇵🇪" },
  { name: "romanian", code: "ro", flag: "🇷🇴" }, // Existing, unchanged
  { name: "romansh", code: "rm", flag: "🇨🇭" },
  { name: "rundi", code: "rn", flag: "🇧🇮" },
  { name: "russian", code: "ru", flag: "🇷🇺" }, // Existing, unchanged
  { name: "samoan", code: "sm", flag: "🇼🇸" },
  { name: "sango", code: "sg", flag: "🇨🇫" },
  { name: "sanskrit", code: "sa", flag: "🇮🇳" },
  { name: "sardinian", code: "sc", flag: "🇮🇹" },
  { name: "serbian", code: "sr", flag: "🇷🇸" },
  { name: "shona", code: "sn", flag: "🇿🇼" },
  { name: "sichuanYi", code: "ii", flag: "🇨🇳" },
  { name: "sindhi", code: "sd", flag: "🇵🇰" },
  { name: "sinhala", code: "si", flag: "🇱🇰" },
  { name: "slovak", code: "sk", flag: "🇸🇰" }, // Existing, unchanged
  { name: "slovenian", code: "sl", flag: "🇸🇮" },
  { name: "somali", code: "so", flag: "🇸🇴" },
  { name: "sothoSouthern", code: "st", flag: "🇱🇸" },
  { name: "spanish", code: "es", flag: "🇪🇸" }, // Existing, unchanged
  { name: "sundanese", code: "su", flag: "🇮🇩" },
  { name: "swahili", code: "sw", flag: "🇹🇿" },
  { name: "swati", code: "ss", flag: "🇸🇿" },
  { name: "swedish", code: "sv", flag: "🇸🇪" }, // Existing, unchanged
  { name: "tagalog", code: "tl", flag: "🇵🇭" },
  { name: "tahitian", code: "ty", flag: "🇵🇫" },
  { name: "tajik", code: "tg", flag: "🇹🇯" },
  { name: "tamil", code: "ta", flag: "🇮🇳" },
  { name: "tatar", code: "tt", flag: "🇷🇺" },
  { name: "telugu", code: "te", flag: "🇮🇳" },
  { name: "thai", code: "th", flag: "🇹🇭" }, // Existing, unchanged
  { name: "tibetan", code: "bo", flag: "🇨🇳" },
  { name: "tigrinya", code: "ti", flag: "🇪🇷" },
  { name: "tongaTongaIslands", code: "to", flag: "🇹🇴" },
  { name: "tsonga", code: "ts", flag: "🇿🇦" },
  { name: "tswana", code: "tn", flag: "🇧🇼" },
  { name: "turkish", code: "tr", flag: "🇹🇷" }, // Existing, unchanged
  { name: "turkmen", code: "tk", flag: "🇹🇲" },
  { name: "twi", code: "tw", flag: "🇬🇭" },
  { name: "uighur", code: "ug", flag: "🇨🇳" },
  { name: "ukrainian", code: "uk", flag: "🇺🇦" }, // Existing, unchanged
  { name: "urdu", code: "ur", flag: "🇵🇰" },
  { name: "uzbek", code: "uz", flag: "🇺🇿" },
  { name: "venda", code: "ve", flag: "🇿🇦" },
  { name: "vietnamese", code: "vi", flag: "🇻🇳" }, // Existing, unchanged
  { name: "volapuk", code: "vo", flag: "🌐" },
  { name: "walloon", code: "wa", flag: "🇧🇪" },
  { name: "welsh", code: "cy", flag: "🏴󠁧󠁢󠁷󠁬󠁳󠁿" },
  { name: "westernFrisian", code: "fy", flag: "🇳🇱" },
  { name: "wolof", code: "wo", flag: "🇸🇳" },
  { name: "xhosa", code: "xh", flag: "🇿🇦" },
  { name: "yiddish", code: "yi", flag: "🇮🇱" },
  { name: "yoruba", code: "yo", flag: "🇳🇬" },
  { name: "zhuang", code: "za", flag: "🇨🇳" },
  { name: "zulu", code: "zu", flag: "🇿🇦" },
];

export const APP_LANGUAGES = [
  { name: "arabic", code: "ar", display: "العربية" },
  { name: "afrikaans", code: "af", display: "Afrikaans" },
  { name: "bulgarian", code: "bg", display: "Български" },
  { name: "catalan", code: "ca", display: "Català" },
  { name: "chineseSimplified", code: "zh-CN", display: "简体中文" },
  { name: "chineseTraditional", code: "zh-TW", display: "繁體中文" },
  { name: "czech", code: "cs", display: "Čeština" },
  { name: "danish", code: "da", display: "Dansk" },
  { name: "dutch", code: "nl", display: "Nederlands" },
  { name: "english", code: "en", display: "English" },
  { name: "estonian", code: "et", display: "Eesti" },
  { name: "finnish", code: "fi", display: "Suomi" },
  { name: "french", code: "fr", display: "Français" },
  { name: "german", code: "de", display: "Deutsch" },
  { name: "greek", code: "el", display: "Ελληνικά" },
  { name: "hindi", code: "hi", display: "हिन्दी" },
  { name: "hungarian", code: "hu", display: "Magyar" },
  { name: "italian", code: "it", display: "Italiano" },
  { name: "indonesian", code: "id", display: "Bahasa Indonesia" },
  { name: "japanese", code: "ja", display: "日本語" },
  { name: "korean", code: "ko", display: "한국어" },
  { name: "latvian", code: "lv", display: "Latviešu" },
  { name: "lithuanian", code: "lt", display: "Lietuvių" },
  { name: "malay", code: "ms", display: "Bahasa Melayu" },
  { name: "norwegian", code: "no", display: "Norsk" },
  { name: "polish", code: "pl", display: "Polski" },
  { name: "portuguese", code: "pt", display: "Português" },
  { name: "portugueseBrazil", code: "pt-BR", display: "Português (Brasil)" },
  { name: "romanian", code: "ro", display: "Română" },
  { name: "russian", code: "ru", display: "Русский" },
  { name: "slovak", code: "sk", display: "Slovenčina" },
  { name: "spanish", code: "es", display: "Español" },
  { name: "swedish", code: "sv", display: "Svenska" },
  { name: "thai", code: "th", display: "ไทย" },
  { name: "turkish", code: "tr", display: "Türkçe" },
  { name: "ukrainian", code: "uk", display: "Українська" },
  { name: "vietnamese", code: "vi", display: "Tiếng Việt" },
];
